import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { PREFERENCES_EMAIL_QUERY_KEY } from 'Data/keys/QueryKeys';
import { NotificationApiV2 } from 'Data/Notification.api.v2';

interface IUseQueryPreferencesEmail {
  enabled: boolean;
}

export const useQueryPreferencesEmail = ({ enabled }: IUseQueryPreferencesEmail) => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [PREFERENCES_EMAIL_QUERY_KEY],
    staleTime: 60 * 5 * 1000, // 5 minutes
    enabled,
    retry: false,
    queryFn: async () => {
      const response = await NotificationApiV2.listPreferencesEmail();
      return [
        ...response.data.FileEmailPreferences,
        ...response.data.TopicEmailPreferences,
        ...response.data.PlottingEmailPreferences,
      ];
    },
  });

  const dataDefault = useMemo(() => [], []);

  return {
    data: data ?? dataDefault,
    refetch,
    isLoading,
    isFetching,
    error,
  };
};
